import type { FuncKey } from './keys';

export const nl: Partial<Record<FuncKey, string>> = {
  'app.eyebrow': 'Wiskunde · Functies',
  'app.title': 'Functies',
  'panel.params': 'Parameters',
  'panel.experiment': 'Experiment',
  'panel.formula': 'Formule',
  'panel.table': 'Tabel',
  'panel.graph': 'Grafiek',
  'panel.verbal': 'Verbale beschrijving',
  'hint.line1': 'Sleep schuifregelaars, bewerk uitdrukkingen, zie de grafiek bijwerken.',
  'hint.line2':
    'Elk experiment richt zich op één bewerking: families, transformaties, samenstelling, inversen, eigenschappen, stuksgewijs, representaties.',
  'experiment.family-zoo.label': 'Functiefamilies',
  'experiment.transformations.label': 'Transformaties',
  'experiment.composition.label': 'Samenstelling',
  'experiment.inverses.label': 'Inverse',
  'experiment.domain-range-lab.label': 'Domein- en bereiklab',
  'experiment.behavior-and-features.label': 'Gedrag & kenmerken',
  'experiment.piecewise-builder.label': 'Stuksgewijs',
  'experiment.representations.label': 'Representaties',
  'experiment.family-zoo.info':
    'Kies een functiefamilie, schuif aan de parameters, zie de grafiek reageren.',
  'experiment.transformations.info':
    'Pas a·f(b·(x − h)) + k toe op een gekozen basisfunctie; zie hoe elke parameter de vorm verandert.',
  'experiment.composition.info':
    'Stel twee functies samen; verken de domeinrestricties die optreden.',
  'experiment.inverses.info':
    'Spiegel een functie in y = x. Domeinrestrictie kan nodig zijn voor inverteerbaarheid.',
  'experiment.domain-range-lab.info':
    'Sleep de intervalhendels om het domein te beperken; het bereik reageert.',
  'experiment.behavior-and-features.info': 'Vind nulpunten, extremen, snijpunten en asymptoten.',
  'experiment.piecewise-builder.info':
    'Bouw stuksgewijze functies; markeer continuïteit en sprongen.',
  'experiment.representations.info':
    'Bekijk dezelfde functie als formule, tabel, grafiek en omschrijving.',
  'btn.reset': 'Reset',
  'btn.reset-view': 'Weergave herstellen',
  'btn.randomise': 'Willekeurig',
  'btn.reveal': 'Tonen',
  'btn.add-piece': 'Stuk toevoegen',
  'btn.remove-piece': 'Stuk verwijderen',
  'btn.clear-all': 'Wis alles',
  'btn.swap': 'Wissel',
  'btn.animate': 'Animeer',
  'btn.auto-find': 'Automatisch vinden',
  'btn.auto-domain': 'Detecteer natuurlijk domein',
  'readout.selected-domain': 'Geselecteerd domein',
  'readout.natural-domain': 'Natuurlijk domein',
  'readout.image-of-domain': 'Bemonsterde y-span over geselecteerd domein',
  'readout.no-finite-outputs': 'Geen eindige uitvoerwaarden',
  'family.linear.label': 'Lineair',
  'family.quadratic.label': 'Kwadratisch',
  'family.cubic.label': 'Kubisch',
  'family.polynomial.label': 'Polynoom',
  'family.rational.label': 'Rationaal',
  'family.exponential.label': 'Exponentieel',
  'family.logarithmic.label': 'Logaritmisch',
  'family.absolute-value.label': 'Absolute waarde',
  'family.square-root.label': 'Wortel',
  'family.sin.label': 'Sinus',
  'family.cos.label': 'Cosinus',
  'family.tan.label': 'Tangens',
  'param.family.label': 'Familie',
  'param.parent.label': 'Toon ouderfunctie',
  'param.predict-mode.label': 'Voorspelmodus',
  'param.a.label': 'a (verticale schaal)',
  'param.b.label': 'b (horizontale schaal)',
  'param.h.label': 'h (horizontale verschuiving)',
  'param.k.label': 'k (verticale verschuiving)',
  'param.base.label': 'Basisfunctie',
  'param.show-stepwise.label': 'Stap voor stap',
  'param.f.label': 'f(x)',
  'param.g.label': 'g(x)',
  'param.order.label': 'Volgorde',
  'param.show-intermediate.label': 'Toon tussenstap g(x₀)',
  'param.show-domain-restriction.label': 'Toon domeinrestrictie',
  'param.restrict.label': 'Beperk domein',
  'param.restrict.not-needed': 'Al een-op-een — geen beperking nodig',
  'param.restrict.use-branch': 'Gebruik een-op-een-tak',
  'param.restrict.unavailable': 'Geen automatische taksuggestie beschikbaar voor deze uitdrukking',
  'param.restrict.custom': 'Definieer een aangepaste een-op-een-tak',
  'param.show-yx.label': 'Toon y = x',
  'param.domain-start.label': 'Domeinbegin',
  'param.domain-end.label': 'Domeineinde',
  'param.output-range-start.label': 'Bereikbegin',
  'param.output-range-end.label': 'Bereikeinde',
  'param.show-excluded.label': 'Toon uitgesloten punten',
  'param.show-derivative.label': 'Toon formele afgeleide',
  'param.pieces.label': 'Voorbeeld',
  'param.piece-expression.label': 'Formule',
  'param.piece-start.label': 'Begin',
  'param.piece-end.label': 'Einde',
  'param.endpoint-included.label': 'Inbegrepen',
  'param.endpoint-excluded.label': 'Uitgesloten',
  'piece.label': 'Stuk',
  'param.highlight-discontinuities.label': 'Markeer discontinuïteiten',
  'param.continuity-check.label': 'Continuïteitscheck',
  'param.range-start.label': 'Begin',
  'param.range-end.label': 'Einde',
  'param.range-step.label': 'Stap',
  'param.precision.label': 'Precisie',
  'param.show-verbal.label': 'Toon verbale beschrijving',
  'feature.vertex': 'Top',
  'feature.zero': 'Nulpunt',
  'feature.extrema': 'Extremen',
  'feature.zeros': 'Nulpunten',
  'feature.extremum-min': 'Minimum',
  'feature.extremum-max': 'Maximum',
  'feature.y-intercept': 'y-snijpunt',
  'feature.vertical-asymptote': 'VA',
  'feature.horizontal-asymptote': 'HA',
  'preset.step.label': 'Stap — −1 / 0 / 1 over drie intervallen',
  'preset.heaviside.label': 'Heaviside — 0 voor x < 0; 1 voor x ≥ 0',
  'preset.tent.label': 'Tent — x + 1 en dan 1 − x op [−1, 1]',
  'preset.relu.label': 'ReLU — 0 voor x ≤ 0; x voor x > 0',
  'preset.custom.label': 'Aangepaste stukken',
  'message.predict-correct': 'Correct!',
  'message.predict-wrong': 'Probeer opnieuw',
  'message.not-invertible-without-restriction': 'Niet inverteerbaar zonder restrictie',
  'message.restriction-not-one-to-one': 'f(x) moet één-op-één zijn op het geselecteerde domein',
  'message.numerical-inverse': 'numerieke inverse van f(x)',
  'message.inverse-domain-unresolved': 'invers domein niet bepaald',
};
